import { Component, Input } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Menu } from '../../../../core/models/menu-permission.model';

@Component({
  selector: 'app-menu-item',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './menu-item.component.html'
})
export class MenuItemComponent {

  @Input() item!: Menu;

  constructor(private router: Router) {}

  get isExpanded(): boolean {

    if (!this.item?.children?.length) {
      return false;
    }

    return this.item.children.some(child =>
      child.route &&
      this.router.url.startsWith(child.route)
    );
  }
}